// ACHTUNG!! Muss JSON sein, keine Komentare!
export default {
  "entrypoints": {
    "contact": {"php": false},
    "cookie-notice": {"php": false},
    "swiper": {"php": false},
    "immoapp": {"php": false},
  }
}
